export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [20, 50];
export const MAX_BULK_SELECTION = 100;

export const BULK_RESULT_STATUS = {
  SUCCESS: 'SUCCESS',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  ERROR: 'ERROR',
};
